export const arrowLeftIcon = {
  body: `

<path d="M1.2565 10.9393C0.670712 11.5251 0.670711 12.4749 1.2565 13.0607L10.8024 22.6066C11.3882 23.1924 12.338 23.1924 12.9238 22.6066C13.5095 22.0208 13.5095 21.0711 12.9238 20.4853L4.43848 12L12.9238 3.51471C13.5095 2.92893 13.5095 1.97918 12.9238 1.39339C12.338 0.807607 11.3882 0.807607 10.8024 1.39339L1.2565 10.9393ZM59.6514 10.5L2.31716 10.5L2.31716 13.5L59.6514 13.5L59.6514 10.5Z" fill="currentColor"/>

`,
  width: 60,
  height: 24,
};
